import TimerCard from './timerCard';
import { useEffect, useState } from 'react';
import AddEditTransactionHeader from '../dashboard/addTransaction/addEditTransactionHeader';
import { usePage } from '../../context/PageContext';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '../../constants/constants';
import SearchInputWithFilters from '../dashboard/SearchInputWithFilters';
import { ITimer } from '../../interface/timer';
import NoData from '../dashboard/noData';
import CollapsibleListLayout from '../collapsibleListLayout/collapsibleListLayout';
import { TimerEmpty } from '../icons';
import { useNavigationStack } from '../../context/NavigationStackContext';
import { useAnalytics } from '../../hooks/useAnalytics';
import { AnalyticsPage } from '../../interface/analytics';
import { useFilteredTimers } from '../../hooks/useFilteredTimers';

const TimerCardListing = () => {
  const { t } = useTranslation();
  const { push, clear } = useNavigationStack();
  const { setTitle } = usePage();
  const { trackPage } = useAnalytics();
  const [refreshCounter, setRefreshCounter] = useState<number>(0);
  const [searchValue, setSearchValue] = useState<string>('');

  const { timers } = useFilteredTimers(searchValue, String(refreshCounter));

  useEffect(() => {
    trackPage(AnalyticsPage.TIMER_LISTING);
    refetch();
  }, [trackPage]);

  const refetch = () => {
    // MainLayout does not get the updated timers from context, so we need to trigger a re-render to get the latest timers from localStorage
    const refreshValue = refreshCounter + 1;
    setRefreshCounter(refreshValue);
    globalThis.dispatchEvent(new CustomEvent('timersUpdated', { detail: refreshValue }));
  };

  const handleAddTimer = () => {
    push(ROUTES.TIMER_ADD_EDIT);
  };
  const handleHome = () => {
    clear();
    push(ROUTES.DASHBOARD);
  };
  useEffect(() => {
    setTitle(
      <AddEditTransactionHeader
        title={t('common:timers.timer')}
        handleHome={handleHome}
        showMenu
        showSettings
      />,
    );
  }, []);
  return (
    <CollapsibleListLayout
      testId="timer-listing"
      header={
        <SearchInputWithFilters
          searchTitle={t('common:timers.searchTimer')}
          handleSearch={(val) => {
            setSearchValue(val);
          }}
          handleRefresh={refetch}
          handleAdd={handleAddTimer}
          tooltipTextForAdd={t('common:timers.addTimer')}
        />
      }
    >
      {timers.map((timer: ITimer) => (
        <TimerCard timerValue={timer} key={timer.id} refetch={refetch} />
      ))}
      {timers?.length === 0 && (
        <div className="flex-grow d-flex justify-center items-center">
          <NoData header={t('common:timers.noTimers')} icon={<TimerEmpty />} />
        </div>
      )}
    </CollapsibleListLayout>
  );
};

export default TimerCardListing;
